import {
  additionalPalette,
  makeStyles,
  theme
} from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  // Matches the display-logic condition row: a bordered block per condition, with the delete control in
  // its top-right rather than inline after the selects.
  conditionContainer: {
    border: `1px solid ${additionalPalette.lightGrey.main}`,
    padding: theme.spacing(0.5, 3, 2, 3)
  },
  operatorContainer: {
    padding: theme.spacing(1, 0)
  },
  linkContainer: {
    padding: theme.spacing(2, 0, 0, 0)
  },
  subtitleContainer: {
    paddingBottom: theme.spacing(2.5)
  },
  // The question label can be long enough to wrap inside the select, which makes it taller than the
  // operator beside it — and then no align-items value looks right, because the two controls genuinely
  // differ in height. Keeping the value on one line makes them equal, so the alignment stops mattering.
  selectsRow: {
    '& .MuiSelect-select': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  optionsContainer: {
    paddingLeft: theme.spacing(2)
  },
  warningText: {
    marginTop: theme.spacing(1)
  }
})

export default useStyles
